import { Resolve } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoggedLayoutResolverService implements Resolve<any> {

  constructor(private authService: AuthService, private _spinner: NgxSpinnerService) {
  }

  resolve() {
    this._spinner.show();
    let currentUser = this.authService.getCurrentUser();
    if (currentUser && currentUser.user) {
      return this.authService.getCurrentUserData(currentUser.user.id)
        .pipe(map(response => {
          if (response.success) {
            const currentuser = {
              token: currentUser.token,
              user: response.data.user
            }
            let rememberMe = localStorage.getItem('rememberMe');
            if (rememberMe == 'true')
            localStorage.setItem('currentUser', JSON.stringify(currentuser));
            else
            sessionStorage.setItem('currentUser', JSON.stringify(currentuser));
          }
          // this._spinner.hide();
          // TODO: reroute here
          return null; // map returns value as an observable so we dont need to use of
        }), catchError((err: any) => {
          // TODO: reroute here
          // this._spinner.hide();
          return of(null);
        }));
    }else{
      // this._spinner.hide();
      return null;
    }

  }
}
